import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70391e87"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row payment-blocks q-col-gutter-md" }
const _hoisted_2 = { class: "payment-block flex" }
const _hoisted_3 = { class: "payment-block__img-wrap flex items-center justify-center" }
const _hoisted_4 = {
  key: 0,
  class: "payment-block__img",
  src: "/images/cap-logo-white.svg"
}
const _hoisted_5 = {
  key: 1,
  class: "payment-block__img",
  src: "/images/tether-usdt-logo.svg"
}
const _hoisted_6 = {
  key: 2,
  class: "payment-block__img",
  src: "/images/usd-coin-usdc-logo.svg"
}
const _hoisted_7 = { class: "payment-block__content q-pa-md col" }
const _hoisted_8 = { class: "flex items-center justify-between q-mb-lg" }
const _hoisted_9 = { class: "text-uppercase" }
const _hoisted_10 = {
  class: "flex items-center",
  style: {"margin-bottom":"10px"}
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {"color":"var(--gray-raven)"},
  class: "q-mr-sm"
}, "Currency:", -1))
const _hoisted_12 = { class: "flex items-center" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {"color":"var(--gray-raven)"},
  class: "q-mr-sm"
}, "Wallet:", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paymentAccounts, (account, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["col-12", { 'col-md-4': !_ctx.isInline }]),
        key: index
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_ctx.paymentSystems[account.paymentSystem] == 'Capitalist')
              ? (_openBlock(), _createElementBlock("img", _hoisted_4))
              : _createCommentVNode("", true),
            (_ctx.paymentSystems[account.paymentSystem] == 'USDT')
              ? (_openBlock(), _createElementBlock("img", _hoisted_5))
              : _createCommentVNode("", true),
            (_ctx.paymentSystems[account.paymentSystem] == 'USDC')
              ? (_openBlock(), _createElementBlock("img", _hoisted_6))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", null, [
                _createElementVNode("b", null, _toDisplayString(_ctx.paymentSystems[account.paymentSystem]), 1),
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.getNetwork(account)), 1)
              ]),
              _createElementVNode("div", null, [
                _createVNode(_component_q_icon, {
                  size: "16px",
                  class: "cursor-pointer",
                  name: _ctx.heroOutline24Trash,
                  onClick: ($event: any) => (_ctx.deleteRow(account.id))
                }, null, 8, ["name", "onClick"])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("b", null, _toDisplayString(_ctx.currencies[account.currency]), 1)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("b", null, _toDisplayString(account.account), 1)
            ])
          ])
        ])
      ], 2))
    }), 128))
  ]))
}